import React, { Component } from 'react'

export default class DateRangeFilter extends Component {
  constructor(props) {
    super(props)
    this.state = { from: '', to: '' }
  }

  handleChange = (field, value) => {
    const next = { ...this.state, [field]: value }
    this.setState(next)
    const { from, to } = next
    if (from || to) {
      this.props.onChange({ filterTerm: `${from}|${to}`, rawValue: { from, to }, column: this.props.column })
    } else {
      this.props.onChange({ filterTerm: null, rawValue: null, column: this.props.column })
    }
  }

  render() {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', padding: '2px' }}>
        <input
          type="date"
          value={this.state.from}
          onChange={e => this.handleChange('from', e.target.value)}
          style={{ fontSize: '11px', width: '100%' }}
          placeholder="Od"
        />
        <input
          type="date"
          value={this.state.to}
          onChange={e => this.handleChange('to', e.target.value)}
          style={{ fontSize: '11px', width: '100%' }}
          placeholder="Do"
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Welds/helpers/DateRangeFilter.js